import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, Activity, CheckCircle2, XCircle } from "lucide-react";

const ROWS = [["attom", "ATTOM (property data)"], ["avadata", "AvaData (skip-trace)"], ["realvalidation", "RealValidation (DNC scrubbing)"]];

export const KeyHealthCard = () => {
  const [s, setS] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/key-health").then((r) => setS(r.data)).catch(() => {}); }, []);

  const run = async () => {
    setBusy(true);
    try { setS((await api.post("/admin/key-health/check")).data); toast.success("Keys checked"); } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };

  return (
    <Card className="mb-5 p-6" data-testid="key-health-card">
      <div className="mb-3 flex flex-wrap items-start justify-between gap-4">
        <div>
          <h3 className="mb-1 flex items-center gap-2 font-display font-bold text-slate-900"><Activity className="h-4 w-4" /> API Key Health</h3>
          <p className="text-xs text-slate-500">Checked every morning at 8 AM Eastern. You get one email when a key starts being rejected, and another only if it breaks again after working.</p>
        </div>
        <Button variant="outline" onClick={run} disabled={busy} data-testid="key-health-check-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Check now"}
        </Button>
      </div>
      {ROWS.map(([k, label]) => {
        const r = s[k];
        return (
          <div key={k} className="flex items-start gap-2 border-b border-slate-100 py-2.5 text-sm" data-testid={`key-health-${k}`}>
            {!r ? <span className="mt-0.5 h-4 w-4 shrink-0 rounded-full bg-slate-200" /> : r.ok ? <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" /> : <XCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-600" />}
            <div>
              <div className="font-semibold text-slate-800">{label}</div>
              <div className={`text-xs ${r && !r.ok ? "text-red-700" : "text-slate-500"}`}>{r ? `${r.ok ? "Working" : "Rejected"} - ${r.message} · ${new Date(r.checked_at).toLocaleString()}` : "Not checked yet"}</div>
            </div>
          </div>
        );
      })}
    </Card>
  );
};
